/**
 * UUID v4 validation utility
 * Validates that a string is in proper UUID v4 format
 */

const UUID_V4_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/**
 * Validates if a string is a valid UUID v4
 * @param uuid - The string to validate
 * @returns true if the string is a valid UUID v4, false otherwise
 */
export function isValidUUID(uuid: string): boolean {
  if (!uuid || typeof uuid !== "string") {
    return false;
  }
  return UUID_V4_REGEX.test(uuid);
}

/**
 * Validates if a string is any valid UUID format (v1-v5)
 * More permissive than isValidUUID which only checks v4
 * @param uuid - The string to validate
 * @returns true if the string is any valid UUID format, false otherwise
 */
export function isValidUUIDAny(uuid: string): boolean {
  if (!uuid || typeof uuid !== "string") {
    return false;
  }
  const anyUuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return anyUuidRegex.test(uuid);
}

/**
 * Generates a new UUID v4
 * @returns a new UUID v4
 */
export function generateUUID(): string {
  return crypto.randomUUID();
}
